module.exports = __webpack_public_path__ + "static/media/universityImport.75648bd5.xlsx";